import { Typography } from "@mui/material";
import React from "react";

const NotFoundComponent = () => {
  return (
    <>
      <Typography textAlign={"center"}>This Route is Not Found</Typography>
    </>
  );
};

export default NotFoundComponent;
